import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect,useState } from 'react';
import './Form.css';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/clientscities';

    const paths = {
        endpointSave: `${endpointBackend}${path}/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/${path}/list`,
        pathView: `/${path}/view`
    }

    const labels = {
        labelTitleAdd: "Novo Município",
        labelTitleEdit: "Editar Município",
        labelTitleView: 'Visualizar Município'
    }

    const hiddenValues = {}

    if (profileFilter.core_application_instance_id) {
        hiddenValues.core_application_instance_id = profileFilter.core_application_instance_id
    }

    const getForm = (values) => {

        let form = {
            hiddenValues: hiddenValues,
            fields: [
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto',
                    uploadPath: '/clientscities/photos/',
                    extensionAccept: '.jpeg,.jpg,.png',
                    limitFileSize: 5,
                    validations: {
                    },
                    columnSize: 12
                },
                !profileFilter.core_application_instance_id && {
                    name: 'core_application_instance_id',
                    type: 'select',
                    label: 'Cliente',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/clients/getall',
                        label: 'company_name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'cnpj',
                    type: 'CNPJ',
                    label: 'CNPJ',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'company_name',
                    type: 'text',
                    label: 'Razão Social',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome Fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'portal_link',
                    type: 'text',
                    label: 'link',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'state_id',
                    type: 'select',
                    label: 'Estado',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/states/getall',
                        label: 'geografic_state_name',
                        value: 'geografic_state_id',
                        params: {
                            filter: {
                                where: {
                                    profileFilter
                                }
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/cities/getall',
                        label: 'city_name',
                        value: 'city_id',
                        params: {
                            filter: {
                                where: {
                                    geografic_state_id:values.state_id,
                                    states: '',
                                    profileFilter
                                }
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'phone',
                    type: 'phone',
                    label: 'Telefone',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'institutional_email',
                    type: 'text',
                    label: 'Email Institucional',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    label: 'Status',
                    options: [
                      { label: 'Ativo', value: '1' },
                      { label: 'Bloqueado', value: '0' },
                    ],
                    validations: {
                      required: true
                    },
                    columnSize: 12
                }   
                     
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById,{id:id})
            }
            if(profileFilter.core_application_instance_id){
                values.core_application_instance_id = profileFilter.core_application_instance_id;
            }
            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    },[])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
